import { render, staticRenderFns } from "./UpdateProduct.vue?vue&type=template&id=6f847e96&scoped=true"
import script from "./UpdateProduct.vue?vue&type=script&lang=js"
export * from "./UpdateProduct.vue?vue&type=script&lang=js"
import style0 from "./UpdateProduct.vue?vue&type=style&index=0&id=6f847e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f847e96",
  null
  
)

export default component.exports